// extracted by mini-css-extract-plugin
module.exports = {"x-button":"XButton_x-button__3_1Wb"};